export default __webpack_public_path__ + "static/media/vust.c6840ee1.png";